<!-- =========================================================================================
    File Name: ProgramFilters.vue
    Description: Program Filter component
========================================================================================== -->


<template>
    <div class="program__filters-container">

        <!-- all -->
        <div class="px-6 py-4">
            <router-link tag="span" class="flex cursor-pointer" :class="{'text-primary': programFilter == 'all'}" :to="`${baseUrl}/all`">
                <feather-icon icon="LayersIcon" :svgClasses="[{'text-primary stroke-current': programFilter == 'all'}, 'h-6 w-6']"></feather-icon>
                <span class="text-lg ml-3">Показать все</span>
            </router-link>
        </div>

        <vs-divider></vs-divider>

        <!-- by status -->
        <div class="px-6 py-4">
            <h5>Со статусом</h5>

            <div class="program__lables-list">
                <router-link tag="span" class="program__label flex items-center mt-6 cursor-pointer" v-for="(state, index) in programStateList" :key="index" :to="`${baseUrl}/${state.tag}`">
                    <div class="ml-1 h-3 w-3 rounded-full mr-4" :class="'border-2 border-solid border-' + state.color" />
                    <span class="text-lg" :class="{'text-primary': programFilter == state.tag}">{{ state.label }}</span>
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'

export default{
    data() {
        return {
            programStateList: modulePartner.programStateList
        }
    },
    computed: {
        programFilter() {
            return this.$route.params.filter
        },
        baseUrl() {
          const path = this.$route.path
          return path.slice(0, path.lastIndexOf("/"))
        }
    }
}
</script>
